import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";
import { isBooleanTrue } from "../../utils/objectUtils";

const LoadingSpinner = ({ isLoading }) => {
    if (isBooleanTrue(isLoading)) {
        return (
            <div className="spinner">
                <div className="w-100 d-flex justify-content-center align-items-center">
                    <Spinner animation="border" role="status" />
                </div>
            </div>
        );
    } else {
        return null;
    }
};

LoadingSpinner.propTypes = {
    loading: PropTypes.bool
};

export default LoadingSpinner;